(function () {
    'use strict';

    angular.module('app')
        .controller('UbicacionFormController', Controller);

    /* @ngInject */
    function Controller($scope, $timeout, item, ModalService, AlertService, Geonames, Lugar) {
        var vm = this;

        vm.item = item;

        vm.propuestas = [];
        vm.selected = {};
        vm.loading = true;


        function initRadio() {
            if (vm.item.lat == null || vm.item.lng == null) return;

            vm.markers.push({
                lat: vm.item.lat,
                lng: vm.item.lng,
                draggable: true
            });

            vm.propuestas.forEach(function (item, index) {
                if (item.lat == vm.item.lat && item.lng == vm.item.lng) {
                    vm.selected = index;
                }
            });
        }

        vm.onChangeRadio = function () {
            if (vm.propuestas && vm.propuestas[vm.selected]) {
                initMarkers();
                vm.center.lat = vm.markers[0].lat = vm.item.lat = vm.propuestas[vm.selected].lat;
                vm.center.lng = vm.markers[0].lng = vm.item.lng = vm.propuestas[vm.selected].lng;
            }
        };

        vm.onChangeLatLong = function () {
            vm.selected = {};

            if (vm.item.lat != null && vm.item.lng != null) {
                if (!vm.markers[0]) {
                    initMarkers();
                }
                vm.center.lat = vm.markers[0].lat = vm.item.lat;
                vm.center.lng = vm.markers[0].lng = vm.item.lng;
            }
        };

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        // Cargamos las propuestas a partir del nombre del lugar
        Geonames.get({nombre: vm.item.nombre}).$promise.then(function (response) {
            vm.propuestas = response;
            initRadio();
            vm.loading = false;

        }, function (error) {
            AlertService.error("admin.lugar.geonames.error");
        });

        vm.save = function () {
            Lugar.updateCoordenadas(vm.item).$promise.then(function (result) {
                console.log("Guardado");
                ModalService.close(result);
            });
        };

        vm.clear = function () {
            ModalService.dismiss('cancel');
        };

        // *** Mapa

        vm.markers = [];

        function initMarkers() {
            if (!vm.markers[0]) {
                vm.markers.push({draggable: true});
            }
        }

        angular.extend(vm, {
            defaults: {
                tileLayer: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                maxZoom: 18,
                minZoom: 2,
                zoom: 3
            },
            center: {
                lat: vm.item.lat,
                lng: vm.item.lng,
                zoom: 5
            },
            events: {
                map: {
                    enable: ['dragend', 'click']
                }
            }
        });

        $scope.$on('leafletDirectiveMap.mymap.click', function (event, args) {
            vm.selected = {};
            initMarkers();
            vm.markers[0].lat = vm.item.lat = args.leafletEvent.latlng.lat;
            vm.markers[0].lng = vm.item.lng = args.leafletEvent.latlng.lng;

        });

        $scope.$on('leafletDirectiveMarker.mymap.dragend', function (event, args) {
            vm.selected = {};
            vm.markers[args.modelName].lat = vm.item.lat = args.model.lat;
            vm.markers[args.modelName].lng = vm.item.lng = args.model.lng;
        });

        // *** Fin mapa

    }
})();
